var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-list-item', [_c('v-list-item-content', [!_vm.small ? _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(_vm.date) + " "), _c('v-chip', {
    staticClass: "ml-2",
    attrs: {
      "x-small": "",
      "color": _vm.statusChipColor
    }
  }, [_vm._v(" " + _vm._s(_vm.statusReadable) + " ")])], 1) : _vm._e(), _c('v-list-item-title', {
    staticClass: "text-truncate"
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', [_vm.hasOpenDetailListener() ? _c('a', {
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.emitOpenDetail.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.titleText) + " ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.titleText) + " ")])]), _c('v-spacer')], 1)]), !_vm.small && _vm.signerText ? _c('v-list-item-subtitle', {
    staticClass: "text-truncate text-xs"
  }, [_vm._v(" " + _vm._s(_vm.signerText) + " ")]) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }